import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "react-feather";
import CustomContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import SidebarMenu from "./SidebarMenu";
import LogoDark from "../../assets/images/logo/logo_dark_1.png";
import LogoIcon from "../../assets/images/logo/logo-icon.png";

const Sidebar = (props) => {
  const customizer = useContext(CustomContext);
  const { toggleIcon, toggleSidebar } = useContext(CustomContext);
  const id = window.location.pathname.split("/").pop();
  const defaultLayout = Object.keys(customizer.layout);

  const layout = id ? id : defaultLayout;
  // eslint-disable-next-line
  const [mainmenu, setMainMenu] = useState([]);

  const [width, setWidth] = useState(0);

  const handleToggle = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    toggleSidebar(!toggleIcon);
  };

  const handleScroll = () => {
    if (window.scrollY > 400) {
      // if (
      //   customizer.settings.sidebar.type.split(' ').pop() ===
      //   'material-type' ||
      //   customizer.settings.sidebar.type.split(' ').pop() ===
      //   'advance-layout'
      // )
      document.querySelector(".sidebar-main").className = "sidebar-main hovered";
    } else {
      if (document.getElementById("sidebar-main")) document.querySelector(".sidebar-main").className = "sidebar-main";
    }
  };

  useEffect(() => {
    document.querySelector(".left-arrow").classList.add("d-none");
    window.addEventListener("resize", handleResize);
    handleResize();
    const currentUrl = window.location.pathname;
    MENUITEMS.map((items) => {
      items.Items.filter((Items) => {
        if (Items.path === currentUrl) setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter((subItems) => {
          if (subItems.path === currentUrl) setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [layout]);

  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  const activeClass = () => {
    // document.querySelector('.sidebar-link').classList.add('active');
    document.querySelector(".bg-overlay1").classList.add("active");
  };

  const setNavActive = (item) => {
    MENUITEMS.map((menuItems) => {
      menuItems.Items.filter((Items) => {
        if (Items !== item) {
          Items.active = false;
          document.querySelector(".bg-overlay1").classList.remove("active");
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
          document.querySelector(".sidebar-links").classList.add("active");
        }
        if (Items.children) {
          Items.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const closeOverlay = () => {
    document.querySelector(".bg-overlay1").classList.remove("active");
    document.querySelector(".sidebar-links").classList.remove("active");
  };

  return (
    <Fragment>
      <div
        className="bg-overlay1"
        onClick={() => {
          closeOverlay();
        }}></div>
      <div className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`} sidebar-layout="stroke-svg" style={{ height: "100vh", bottom: 0 }}>
        <div className="sidebar-header-wrapper" style={{ backgroundColor: "#000000" }}>
          {toggleIcon ? (
            <Fragment>
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard`}
                className="d-flex align-items-center justify-content-center"
                style={{ flexShrink: 0, textDecoration: "none" }}
              >
                <div className="sidebar-logo-pill" style={{ padding: "4px 6px", borderRadius: "8px" }}>
                  <img
                    src={LogoIcon}
                    alt="CLINICDOTS"
                    style={{
                      width: "25px",
                      height: "25px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </Link>
              <button
                type="button"
                className="sidebar-toggle-btn"
                onClick={handleToggle}
                title="Expand sidebar"
                aria-label="Expand sidebar"
              >
                <ChevronRight size={18} strokeWidth={2.5} />
              </button>
            </Fragment>
          ) : (
            <Fragment>
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard`}
                className="d-flex align-items-center justify-content-center flex-grow-1"
                style={{ overflow: "hidden", textDecoration: "none", marginRight: "8px" }}
              >
                <div
                  className="sidebar-logo-pill"
                  style={{
                    width: "100%",
                    maxWidth: "202px",
                    height: "52px",
                    padding: "3px 10px",
                    borderRadius: "10px",
                  }}
                >
                  <img
                    src={LogoDark}
                    alt="CLINICDOTS LABORATORY"
                    style={{
                      maxHeight: "46px",
                      maxWidth: "185px",
                      width: "auto",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </Link>
              <button
                type="button"
                className="sidebar-toggle-btn"
                onClick={handleToggle}
                title="Collapse sidebar"
                aria-label="Collapse sidebar"
              >
                <ChevronLeft size={18} strokeWidth={2.5} />
              </button>
            </Fragment>
          )}
        </div>
        {/* sidebartoogle={sidebartoogle} */}
        <SidebarMenu setMainMenu={setMainMenu} props={props} setNavActive={setNavActive} activeClass={activeClass} width={width} />
      </div>
    </Fragment>
  );
};

export default Sidebar;
